var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

module.exports = function (e) {
  var t = {};

  function n(o) {
    if (t[o]) return t[o].exports;
    var a = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, o) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      n.d(o, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return o;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 76);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  76: function _(e, t, n) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = o(n(1)),
        r = o(n(2)),
        i = n(3),
        l = o(n(77)),
        s = o(n(78)),
        u = {
      threedots: l.default,
      twocircles: s.default,
      undefined: l.default
    },
        d = r.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 10000;\n  background-color: ", ";\n  ", ";\n"])), function (_ref) {
      var e = _ref.position;
      return i.globalStyles.fullBleed(e);
    }, function (_ref2) {
      var e = _ref2.bgColor;
      return e;
    }, function (_ref3) {
      var e = _ref3.loading,
          t = _ref3.duration;
      return i.globalStyles.fade(e, (t || 1) / 1e3);
    });

    t.default = function (_ref4) {
      var e = _ref4.loading,
          t = _ref4.duration,
          n = _ref4.position,
          _ref4$name = _ref4.name,
          o = _ref4$name === void 0 ? "threedots" : _ref4$name,
          r = _ref4.color,
          _ref4$bgColor = _ref4.bgColor,
          i = _ref4$bgColor === void 0 ? "rgba(255,255,255,0.8)" : _ref4$bgColor;
      var l = u[o];
      return e ? a.default.createElement(d, {
        className: "lego-spinner-overlay",
        loading: e ? 1 : 0,
        duration: t,
        position: n,
        bgColor: i
      }, a.default.createElement(l, {
        className: "lego-spinner",
        color: r
      })) : null;
    };
  },
  77: function _(e, t, n) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = o(n(1)),
        r = o(n(2)),
        i = n(3),
        l = i.colorPalettes.KineduPalette,
        s = r.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .spinner {\n    width: 70px;\n    text-align: center;\n  }\n\n  .spinner > div {\n    width: 17px;\n    height: 17px;\n    background-color: ", ";\n\n    border-radius: 100%;\n    display: inline-block;\n    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n    animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  }\n\n  .spinner .bounce1 {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  .spinner .bounce2 {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%, 80%, 100% { -webkit-transform: scale(0) }\n    40% { -webkit-transform: scale(1.0) }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%, 80%, 100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    } 40% {\n      -webkit-transform: scale(1.0);\n      transform: scale(1.0);\n    }\n  }\n"])), function (_ref5) {
      var e = _ref5.color;
      return e;
    }),
        u = function u(_ref6) {
      var e = _ref6.color;
      return a.default.createElement(s, {
        color: e
      }, a.default.createElement("div", {
        className: "spinner"
      }, a.default.createElement("div", {
        className: "bounce1"
      }), a.default.createElement("div", {
        className: "bounce2"
      }), a.default.createElement("div", {
        className: "bounce3"
      })));
    };

    u.defaultProps = {
      color: l.kineduShade
    }, t.default = u;
  },
  78: function _(e, t, n) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = o(n(1)),
        r = o(n(2)),
        i = n(3),
        l = i.colorPalettes.KineduPalette,
        s = r.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .spinner {\n    margin: 100px auto;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    text-align: center;\n\n    -webkit-animation: sk-rotate 2.0s infinite linear;\n    animation: sk-rotate 2.0s infinite linear;\n  }\n\n  .dot1, .dot2 {\n    width: 60%;\n    height: 60%;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    background-color: ", ";\n    border-radius: 100%;\n\n    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;\n    animation: sk-bounce 2.0s infinite ease-in-out;\n  }\n\n  .dot2 {\n    top: auto;\n    bottom: 0;\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s;\n  }\n\n  @-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}\n  @keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}\n\n  @-webkit-keyframes sk-bounce {\n    0%, 100% { -webkit-transform: scale(0.0) }\n    50% { -webkit-transform: scale(1.0) }\n  }\n\n  @keyframes sk-bounce {\n    0%, 100% {\n      transform: scale(0.0);\n      -webkit-transform: scale(0.0);\n    } 50% {\n      transform: scale(1.0);\n      -webkit-transform: scale(1.0);\n    }\n  }\n"])), function (_ref7) {
      var e = _ref7.color;
      return e;
    }),
        u = function u(_ref8) {
      var e = _ref8.color;
      return a.default.createElement(s, {
        color: e
      }, a.default.createElement("div", {
        className: "spinner"
      }, a.default.createElement("div", {
        className: "dot1"
      }), a.default.createElement("div", {
        className: "dot2"
      })));
    };

    u.defaultProps = {
      color: l.kineduShade
    }, t.default = u;
  }
});